import {useEffect, useRef, useState} from 'react'

import useEventCallback from './useEventCallback'

export type EqualityFn<T> = (a: T, b: T) => boolean
const isEqual = <T>(a: T, b: T) => a === b
export default function useEventSelector<I, O>(
  selector: (input?: I) => O,
  equalityFn: EqualityFn<O> = isEqual,
): [O, (input: I) => void] {
  const [value, setValue] = useState(selector)
  const isMounted = useRef(true)
  useEffect(
    () => () => {
      isMounted.current = false
    },
    [],
  )
  const handler = useEventCallback((input: I) => {
    const newValue = selector(input)

    if (isMounted.current && !equalityFn(newValue, value)) {
      setValue(newValue)
    }
  })
  return [value, handler]
}
